import ModelInput from './ModelInput';

export default ModelInput;
